import { inject, Injectable } from '@angular/core';
import { WebsiteGroup } from '../../shared/models/website.models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebsiteGroupsResponse, WebsiteGroupItem } from '../../shared/models/website-group.models';

@Injectable({
  providedIn: 'root',
})
export class WebsiteGroupsService {
  private http = inject(HttpClient);

  getGroup(id: number): Observable<WebsiteGroup> {
    return this.http.get<WebsiteGroup>(`/websites/groups/${id}`);
  }

  getGroupByWebsite(id: number): Observable<WebsiteGroup> {
    return this.http.get<WebsiteGroup>(`/websites/${id}/group`);
  }

  searchGroups({
    page,
    owner,
    itemsPerPage,
    domain,
  }: {
    owner?: string;
    page?: number;
    itemsPerPage?: number;
    domain?: string;
  }): Observable<WebsiteGroupsResponse> {
    const query = new URLSearchParams();
    if (page) query.set('page', String(page));

    if (owner) query.set('owner', owner);

    if (domain) query.set('domain', domain);

    if (!itemsPerPage) itemsPerPage = 10;

    query.set('itemsPerPage', String(itemsPerPage));

    return this.http.get<WebsiteGroupsResponse>(`/websites/groups?${query.toString()}`);
  }

  getServerGroups(server: string, owner?: string): Observable<WebsiteGroupItem[]> {
    let params = new HttpParams();

    if (owner) params = params.set('owner', owner);

    return this.http.get<WebsiteGroupItem[]>(`/websites/groups/servers/${server}`, {
      params,
    });
  }

  createGroup(id: number, mainWebsiteId: number, ownerId: number): Observable<WebsiteGroup> {
    return this.http.post<WebsiteGroup>('/websites/groups', {
      id,
      ownerId,
      mainWebsite: mainWebsiteId,
    });
  }

  deleteGroup(id: number): Observable<void> {
    return this.http.delete<void>(`/websites/groups/${id}`);
  }

  updateGroupWebsites(groupId: number, websites: number[]): Observable<void> {
    return this.http.patch<void>(`/websites/groups/${groupId}`, {
      ids: websites,
    });
  }

  migrateGroup(id: number, sourceServerId: string, targetServerId: string): Observable<void> {
    return this.http.patch<void>(`/websites/groups/${id}/migrate`, {
      originServerSource: sourceServerId,
      originServerTarget: targetServerId,
    });
  }
}
